import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import moment from "moment";
import BackArrow from "../../../assets/images/back-arrow.svg";
import eyeSlashIcon from "../../../assets/images/slash-eye-icon.svg";
import eyeIcon from "../../../assets/images/eye.svg";
import UserContext from "../../../context/userContext";
import Service from "../../../shared/_services/inventory.service";
import { confirm } from "react-confirm-box";
import { useSnackbar } from "notistack";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Spinner } from "react-bootstrap";


const initialValues = {
  CanoID: "",
  CompanyName: "",
  CompanyCode: "",
  databaseName: "",
  url: "",
  GUID: "",
  AuthID: "",
  databaseURL: "",
  databasePassword: "",
  databaseUser: "",
  SAPURL: "",
  SAPClientID: "",
  SAPRefreshToken: "",
  SAPURL2: "",
  SAPClientSecret: "",
  TypeOfProduct: "",
  StripePaymentStatus: "",
  StripePaymentCharged: "",
  PricePerWorker: 0,
  PricePerInventoryStaff: 0,
  PricePerHybridUser: 0,
  PricePerField: 0,
  isTrial: false,
  TrialDays: 0,
  IsRestrictedUser: false,
  UserLimit: 0,
  CardLimit: 0,
  JoiningDate: "",
  Disabled: "",
  RestrictedCompanies: [],
  SpectrumClientID: "",
  SpectrumClientSecret: "",
  isBankingAccess: false,
  isInventoryAccess: false,
  isExpensesAccess: false
};

const EditCompany = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [passwordIcon, setPasswordIcon] = useState(eyeSlashIcon);
  const [isTrialOn, setIsTrialOn] = useState(false);
  const [isRestrictedUserOn, setIsRestrictedUserOn] = useState(false);
  const [userLimitCount, setUserLimitCount] = useState()
  const [isChecked, setIsChecked] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const user = useContext(UserContext);
  const accessToken = user?.id;
  const { enqueueSnackbar } = useSnackbar();
  const Navigate = useNavigate();
  const { id } = useParams();
  // const [canoId, setCanoId] = useState();
  const [usersCount, setUsersCount] = useState();
  const [formInitialValues, setFormInitialValues] = useState(initialValues);
  const [isLoading, setIsLoading] = useState(true);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
    setPasswordIcon(showPassword ? eyeSlashIcon : eyeIcon);
  };

  const handleTrialToggle = () => {
    setIsTrialOn(!isTrialOn); // Toggle the state when the button is clicked
  };


  // Update getUsers to accept the company ID as an argument
  const getUsers = async (companyId) => {
    if (!companyId) return;

    try {
      const response = await Service.getCanoUser(companyId);
      console.log("response user count", response.length)
      if (!response.error) {
        setUsersCount(response?.length);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    Service.getCompanyById(id, enqueueSnackbar).then((response) => {
      if (!response.error) {
        setCompanyData(response);
        const {
          id: companyId,
          CompanyName,
          CompanyCode,
          databaseName,
          TypeOfProduct,
          url,
          AuthID,
          connectionString,
          databaseURL,
          databasePassword,
          databaseUser,
          SAPURL,
          SAPClientID,
          SAPRefreshToken,
          SAPURL2,
          SAPClientSecret,
          PricePerWorker,
          PricePerInventoryStaff,
          PricePerHybridUser,
          PricePerField,
          StripePaymentStatus,
          StripePaymentCharged,
          TrialDays,
          JoiningDate,
          Disabled,
          StripePaymentMethodID,
          StripeCustomerID,
          AllowMultiCompJobReq,
          RestrictedCompanies,
          IsRestrictedUser,
          UserLimit,
          CardLimit,
          SpectrumClientID,
          SpectrumClientSecret,
          isBankingAccess,
          isInventoryAccess,
          isExpensesAccess,
        } = response;

        // 1. Set component states (non-form fields)
        setIsRestrictedUserOn(IsRestrictedUser);
        setUserLimitCount(UserLimit);
        setIsTrialOn(TrialDays);
        setIsChecked(AllowMultiCompJobReq);

        // 2. Prepare and set the state for Formik's initial values
        const newFormValues = {
          CanoID: companyId,
          CompanyName: CompanyName,
          CompanyCode: CompanyCode,
          databaseName: databaseName,
          TypeOfProduct: TypeOfProduct,
          url: url,
          AuthID: AuthID,
          databaseURL: databaseURL,
          databasePassword: databasePassword,
          connectionString: connectionString,
          databaseUser: databaseUser,
          SAPURL: SAPURL,
          SAPClientID: SAPClientID,
          SAPRefreshToken: SAPRefreshToken,
          SAPURL2: SAPURL2,
          SAPClientSecret: SAPClientSecret,
          StripePaymentStatus: StripePaymentStatus,
          StripePaymentCharged: StripePaymentCharged,
          PricePerWorker: PricePerWorker,
          PricePerInventoryStaff: PricePerInventoryStaff,
          PricePerHybridUser: PricePerHybridUser,
          PricePerField: PricePerField,
          isBankingAccess: isBankingAccess,
          isInventoryAccess: isInventoryAccess,
          isExpensesAccess: isExpensesAccess ?? false,
          TrialDays: TrialDays,
          TrialEndsOn: moment(JoiningDate)
            .add(TrialDays, "days")
            .format("DD-MMM-YYYY"),
          JoiningDate: JoiningDate,
          Disabled: Disabled,
          StripeCustomerID: StripeCustomerID,
          StripePaymentMethodID: StripePaymentMethodID,
          RestrictedCompanies: RestrictedCompanies,
          SpectrumClientID: SpectrumClientID,
          SpectrumClientSecret: SpectrumClientSecret,
          CardLimit: CardLimit
        };

        setFormInitialValues(newFormValues);
        getUsers(companyId);
      }
      setIsLoading(false);
    }).catch(error => {
      console.error("Fetch error:", error);
      setIsLoading(false); 
    });
  }, [id, enqueueSnackbar, accessToken]);


  const validationSchema = Yup.object().shape({
    CanoID: Yup.string().required("Cano ID  is required"),
    CompanyName: Yup.string().required("Cano Account Name is required"),
    CompanyCode: Yup.string().required("Cano Account Code is required"),
    databaseName: Yup.string().required("Email is required"),
    url: Yup.string()
      .required("URL is required")
      .matches(
        /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
        "Invalid URL format. Please enter a valid URL."
      ),
    AuthID: Yup.string().required("Auth ID is required"),
    databaseURL: Yup.string().required("SQL URL is required"),
    databasePassword: Yup.string().required("SQL Password is required"),
    databaseUser: Yup.string().required("Database User is required"), // Added this line
    SAPURL: Yup.string(),
    SAPClientID: Yup.string(),
    SAPRefreshToken: Yup.string(),
    SAPURL2: Yup.string(),
    SAPClientSecret: Yup.string(),
    TypeOfProduct: Yup.string().required("Product Type is required"),
    isTrial: Yup.boolean(),
    TrialDays: Yup.number().when("isTrial", {
      is: true,
      then: Yup.number().required(
        "Trial Days are required when Trial is enabled"
      ),
    }),
    IsRestrictedUser: Yup.boolean(),
    UserLimit: Yup.number()
      .nullable()
      .when("IsRestrictedUser", {
        is: true,
        then: (schema) => schema
          .required("User Limit is required")
          .min(1, "User Limit should be at least 1 user")
          .integer("User Limit must be a whole number"),
        otherwise: (schema) => schema
          .notRequired()
          .min(0, "User Limit cannot be negative")
          .integer("User Limit must be a whole number"),
      }),
    isBankingAccess: Yup.boolean(),
    isInventoryAccess: Yup.boolean(),
    isExpensesAccess: Yup.boolean(),
    CardLimit: Yup.number()
    .nullable()
    .min(0, "Card Limit cannot be negative")
    .integer("Card Limit must be a whole number"),
  });

  // Program data update button
  const formik = useFormik({
    initialValues: formInitialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {

      if (isRestrictedUserOn && userLimitCount <= 0) {
        formik.setFieldTouched('UserLimit', true, false);
        formik.setFieldError('UserLimit', 'User Limit is required and must be greater than 0');
        return; // Stop form submission
      }
      const result = await confirm(
        "Do you want to update Cano Account?",
        options
      );

      if (result) {
        const data = {
          ...values,
          IsRestrictedUser: isRestrictedUserOn,
          UserLimit: isRestrictedUserOn
            ? userLimitCount ?? companyData.UserLimit
            : 0,
          AllowMultiCompJobReq: isChecked,
          connectionString: companyData.connectionString,
          CardLimit: values.CardLimit ?? "",
        };

        Service.EditCompany(id, data, enqueueSnackbar).then((response) => {
          if (response.status === "success") {
            enqueueSnackbar(response.message.status, { variant: "success" });
            Navigate("/company");
          } else {
            enqueueSnackbar(response.message, { variant: "error" });
          }
        });
      }
    },
  });

  const options = {
    render: (message, onConfirm, onCancel) => {
      return (
        <div className="conform_modal">
          <h3>Are you Sure?</h3>
          <p> {message} </p>
          <div className="conform_box_btn">
            <button className="cancel_btn" onClick={onCancel}>
              Cancel
            </button>
            <button className="conform_btn" onClick={onConfirm}>
              Confirm
            </button>
          </div>
        </div>
      );
    },
  };

  return (
    <Container fluid>
      <Row>
        <Col lg={12}>
          <div className="page-heading d-flex">
            <Link to="/company">
              <img src={BackArrow} alt="back arrow" />
            </Link>
            <h4>Edit Cano Account</h4>
          </div>
        </Col>
      </Row>
      {isLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '70vh',color: "skyblue" }}>
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
        ) : (
      <Form onSubmit={formik.handleSubmit}>
        <div className="white-box-sec mt-3">
          <Row>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Company Name"
                  // readOnly
                  name="CompanyName"
                  {...formik.getFieldProps("CompanyName")}
                  value={formik.values.CompanyName}
                />
                {formik.touched.CompanyName && formik.errors.CompanyName ? (
                  <div className="error-msg">{formik.errors.CompanyName}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>CanoID</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  placeholder="Enter API ConoID"
                  name="CanoID"
                  {...formik.getFieldProps("CanoID")}
                  value={formik.values.CanoID}
                />
                {formik.touched.CanoID && formik.errors.CanoID ? (
                  <div className="error-msg">{formik.errors.CanoID}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>API Company Code</Form.Label>
                <Form.Control
                  type="text"
                  // readOnly
                  placeholder="Enter API Company Code"
                  name="CompanyCode"
                  {...formik.getFieldProps("CompanyCode")}
                  value={formik.values.CompanyCode}
                />
                {formik.touched.CompanyCode && formik.errors.CompanyCode ? (
                  <div className="error-msg">{formik.errors.CompanyCode}</div>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>Database Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter databaseName "
                  name="databaseName"
                  {...formik.getFieldProps("databaseName")}
                />
                {formik.touched.databaseName && formik.errors.databaseName ? (
                  <div className="error-msg">{formik.errors.databaseName}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>URL</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter URl"
                  name="url"
                  {...formik.getFieldProps("url")}
                />
                {formik.touched.url && formik.errors.url ? (
                  <div className="error-msg">{formik.errors.url}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>Auth ID</Form.Label>
                <Form.Control
                  type="text"
                  // readOnly
                  name="AuthID"
                  placeholder="Enter Auth ID"
                  {...formik.getFieldProps("AuthID")}
                />
                {formik.touched.AuthID && formik.errors.AuthID ? (
                  <div className="error-msg">{formik.errors.AuthID}</div>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>Spectrum Client ID</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter Spectrum Client ID"
                  name="SpectrumClientID"
                  {...formik.getFieldProps("SpectrumClientID")}
                />
                {formik.touched.SpectrumClientID && formik.errors.SpectrumClientID ? (
                  <div className="error-msg">{formik.errors.SpectrumClientID}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>Spectrum Client Secret</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter Spectrum Client Secret"
                  name="SpectrumClientSecret"
                  {...formik.getFieldProps("SpectrumClientSecret")}
                />
                {formik.touched.SpectrumClientSecret && formik.errors.SpectrumClientSecret ? (
                  <div className="error-msg">{formik.errors.SpectrumClientSecret}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>Database URL</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter SQL URL"
                  name="databaseURL"
                  {...formik.getFieldProps("databaseURL")}
                />
                {formik.touched.databaseURL && formik.errors.databaseURL ? (
                  <div className="error-msg">{formik.errors.databaseURL}</div>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <Form.Group className="pb-1">
                <Form.Label>Database Password</Form.Label>
                <div className="eye-icon">
                  <img
                    src={passwordIcon}
                    className="hide-pass"
                    alt="eye-icon"
                    onClick={togglePasswordVisibility}
                  />
                </div>
                <Form.Control
                  placeholder="SQL Password"
                  // readOnly
                  id="exampleInputPassword1"
                  type={showPassword ? "text" : "password"}
                  name="databasePassword"
                  {...formik.getFieldProps("databasePassword")}
                />
                {formik.touched.databasePassword &&
                  formik.errors.databasePassword ? (
                  <div className="error-msg">
                    {formik.errors.databasePassword}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>Product Type</Form.Label>
                <Form.Control
                  as="select"
                  name="TypeOfProduct"
                  className="sel-product-type"
                  {...formik.getFieldProps("TypeOfProduct")}
                >
                  <option>Inventory</option>
                  <option>Mobile</option>
                  <option>Hybrid</option>
                  <option>Field</option>
                </Form.Control>
                {formik.touched.TypeOfProduct && formik.errors.TypeOfProduct ? (
                  <div className="error-msg">{formik.errors.TypeOfProduct}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>Database User</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter SQL URL"
                  name="databaseUser"
                  {...formik.getFieldProps("databaseUser")}
                />
                {formik.touched.databaseURL && formik.errors.databaseUser ? (
                  <div className="error-msg">{formik.errors.databaseUser}</div>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
        </div>
        <div className="white-box-sec mt-3">
          <Row>
            <Col>
              <h6 className="set-price">SAP</h6>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>SAP URL</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter SQL URL"
                  name="SAPURL"
                  {...formik.getFieldProps("SAPURL")}
                />
                {formik.touched.SAPURL && formik.errors.SAPURL ? (
                  <div className="error-msg">{formik.errors.SAPURL}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>SAP Client ID</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter SAP Client ID"
                  name="SAPClientID"
                  {...formik.getFieldProps("SAPClientID")}
                />
                {formik.touched.SAPClientID && formik.errors.SAPClientID ? (
                  <div className="error-msg">{formik.errors.SAPClientID}</div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>SAP Client Secret</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter SAP Client Secret"
                  name="SAPClientSecret"
                  {...formik.getFieldProps("SAPClientSecret")}
                />
                {formik.touched.SAPClientSecret &&
                  formik.errors.SAPClientSecret ? (
                  <div className="error-msg">
                    {formik.errors.SAPClientSecret}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>SAP Refresh Token</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter SAP Refresh Token"
                  name="SAPRefreshToken"
                  {...formik.getFieldProps("SAPRefreshToken")}
                />
                {formik.touched.SAPRefreshToken &&
                  formik.errors.SAPRefreshToken ? (
                  <div className="error-msg">
                    {formik.errors.SAPRefreshToken}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group className="pb-2">
                <Form.Label>SAP URL2</Form.Label>
                <Form.Control
                  // readOnly
                  type="text"
                  placeholder="Enter SAP URL2"
                  name="SAPURL2"
                  {...formik.getFieldProps("SAPURL2")}
                />
                {formik.touched.SAPURL2 && formik.errors.SAPURL2 ? (
                  <div className="error-msg">{formik.errors.SAPURL2}</div>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
        </div>
        <div className="white-box-sec mt-3 add_company_setprice">
          <Row>
            <Col>
              <h6 className="set-price">Set Price</h6>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <Form.Group className="pb-2">
                <Form.Label>Price per Worker</Form.Label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter Price per Worker"
                    name="PricePerWorker"
                    {...formik.getFieldProps("PricePerWorker")}
                  />
                </div>
                {formik.touched.PricePerWorker &&
                  formik.errors.PricePerWorker ? (
                  <div className="error-msg">
                    {formik.errors.PricePerWorker}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group className="pb-2">
                <Form.Label>Price per Inventory Staff</Form.Label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter Price per Inventory Staff"
                    name="PricePerInventoryStaff"
                    {...formik.getFieldProps("PricePerInventoryStaff")}
                  />
                </div>
                {formik.touched.PricePerInventoryStaff &&
                  formik.errors.PricePerInventoryStaff ? (
                  <div className="error-msg">
                    {formik.errors.PricePerInventoryStaff}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group className="pb-2">
                <Form.Label>Price per Hybrid User</Form.Label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter Price per Hybrid User"
                    name="PricePerHybridUser"
                    {...formik.getFieldProps("PricePerHybridUser")}
                  />
                </div>
                {formik.touched.PricePerHybridUser &&
                  formik.errors.PricePerHybridUser ? (
                  <div className="error-msg">
                    {formik.errors.PricePerHybridUser}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
            <Col lg={3}>
              <Form.Group className="pb-2">
                <Form.Label>Price per Field</Form.Label>
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">$</span>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter Price per Field"
                    name="PricePerField"
                    {...formik.getFieldProps("PricePerField")}
                  />
                </div>
                {formik.touched.PricePerField &&
                  formik.errors.PricePerField ? (
                  <div className="error-msg">
                    {formik.errors.PricePerField}
                  </div>
                ) : null}
              </Form.Group>
            </Col>
          </Row>
        </div>
        <div className="white-box-sec mt-3">
          <Row>
            <Col lg={2}>
              <div className="d-flex mt-4">
                <h6 className="mr-2">Trial</h6>
                <Toggle
                  checked={isTrialOn}
                  onChange={handleTrialToggle}
                  disabled
                  icons={{
                    checked: (
                      <div style={{ display: "flex" }}>
                        <i className="fas fa-check-circle"></i>
                      </div>
                    ),
                    unchecked: (
                      <div style={{ display: "flex" }}>
                        <i className="fas fa-times-circle"></i>
                      </div>
                    ),
                  }}
                />
              </div>
            </Col>
            {isTrialOn && formik.values.TrialDays > 0 ? (
              // Render Days field only if the toggle is checked
              <>
                <Col lg={3}>
                  <Form.Group className="pb-2">
                    <Form.Label>Trial Days</Form.Label>
                    <Form.Control
                      type="text"
                      disabled
                      placeholder="Enter No of Days"
                      name="TrialDays"
                      {...formik.getFieldProps("TrialDays")}
                    />
                    {formik.touched.TrialDays && formik.errors.TrialDays ? (
                      <div className="error-msg">{formik.errors.TrialDays}</div>
                    ) : null}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <Form.Group className="pb-2">
                    <Form.Label>Trial Ends on</Form.Label>
                    <Form.Control
                      type="text"
                      name="TrialEnds"
                      disabled
                      {...formik.getFieldProps("TrialEndsOn")}
                    />
                  </Form.Group>
                </Col>
              </>
            ) : (
              ""
            )}

            <Col lg={4}>
              <Form.Group className="d-flex mt-4">
                <Form.Label>Allow Multi Company Job Requisition</Form.Label>
                <Form.Check
                  type="switch" // You can use 'checkbox' here for a checkbox instead
                  id="isActiveSwitch" // Unique ID for the input
                  label=""
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
              </Form.Group>
            </Col>

            <Col lg={2}>
              <div className="d-flex mt-4">
                <h6 className="mr-2">Restrict User</h6>
                <Toggle
                  checked={isRestrictedUserOn}
                  onChange={() => {
                    const newValue = !isRestrictedUserOn;
                    setIsRestrictedUserOn(newValue);
                    if (!newValue) setUserLimitCount(0);

                    formik.setValues({
                      ...formik.values,
                      IsRestrictedUser: newValue,
                      UserLimit: newValue ? "" : 0,
                    });

                    if (!newValue) {
                      formik.setFieldTouched("UserLimit", false);
                    }
                  }}
                />

              </div>
            </Col>

            {isRestrictedUserOn && (
              <Col lg={3}>
                <Form.Group className="pb-2">
                  <Form.Label>User Limit</Form.Label>
                  <div className="input-group">
                    <Form.Control
                      type="number"
                      placeholder="Enter no of users"
                      name="UserLimit"
                      value={userLimitCount === 0 ? "" : userLimitCount}
                      onChange={(e) => {
                        let newLimit = e.target.value;

                        if (newLimit === "") {
                          setUserLimitCount("");
                          formik.setFieldValue("UserLimit", "");
                        } else {
                          let parsedLimit = parseInt(newLimit);
                          console.log("usersCount", usersCount)
                          console.log("parsedLimit", parsedLimit)
                          setUserLimitCount(parsedLimit);
                          formik.setFieldValue("UserLimit", parsedLimit);

                          if (parsedLimit < usersCount) {
                            enqueueSnackbar("The entered count cannot be less than the existing user count.", { variant: "error" });
                          }
                        }
                        formik.setFieldTouched("UserLimit", true, false);
                      }}
                    />
                  </div>
                  {formik.touched.UserLimit && formik.errors.UserLimit ? (
                    <div className="error-msg">{formik.errors.UserLimit}</div>
                  ) : null}
                </Form.Group>
              </Col>
            )}
          </Row>
        </div>
        <div className="white-box-sec mt-3">
          <Row>
            {/* Banking Access Toggle */}
            <Col lg={3}>
              <div className="d-flex mt-4">
                <h6 className="mr-2">Activate Banking Permissions</h6>
                <Toggle
                  checked={formik.values.isBankingAccess}
                  onChange={(e) => formik.setFieldValue("isBankingAccess", e.target.checked)}
                  icons={{
                    checked: <i className="fas fa-check-circle"></i>,
                    unchecked: <i className="fas fa-times-circle"></i>,
                  }}
                />
              </div>
            </Col>
            {/* Inventory Access Toggle */}
            <Col lg={3}>
              <div className="d-flex mt-4">
                <h6 className="mr-2">Activate Inventory Permissions</h6>
                <Toggle
                  checked={formik.values.isInventoryAccess}
                  onChange={(e) => formik.setFieldValue("isInventoryAccess", e.target.checked)}
                  icons={{
                    checked: <i className="fas fa-check-circle"></i>,
                    unchecked: <i className="fas fa-times-circle"></i>,
                  }}
                />
              </div>
            </Col>
            {/* Expense Access Toggle */}
            <Col lg={3}>
              <div className="d-flex mt-4">
                <h6 className="mr-2">Expense Access</h6>
                <Toggle
                  checked={formik.values.isExpensesAccess}
                  onChange={(e) => formik.setFieldValue("isExpensesAccess", e.target.checked)}
                  icons={{
                    checked: <i className="fas fa-check-circle"></i>,
                    unchecked: <i className="fas fa-times-circle"></i>,
                  }}
                />
              </div>
            </Col>

            {/* <Col lg={3}>
              <Form.Group className="pb-2">
                <Form.Label>Card Limit</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter card limit"
                  name="CardLimit"
                  min="0"
                  value={formik.values.CardLimit || ""}
                  {...formik.getFieldProps("CardLimit")}

                  onChange={(e) => {
                    const value = e.target.value;
                
                    // Prevent negative values
                    if (value === "" || Number(value) >= 0) {
                      formik.setFieldValue("CardLimit", value);
                    }
                  }}
                />
                {formik.touched.CardLimit && formik.errors.CardLimit ? (
                  <div className="error-msg">{formik.errors.CardLimit}</div>
                ) : null}
              </Form.Group>
            </Col> */}
          </Row>
        </div>
        <div className="button-footer new-comp my-5">
          <Row>
            <Col lg={6} className="col-6">
              <div className="cancel-btn">
                <Link to="/company">
                  <Button>Cancel</Button>
                </Link>
              </div>
            </Col>
            <Col lg={6} className="col-6">
              <div className="submit-btn float-right">
                <button type="submit" disabled={formik.isSubmitting}>
                  Submit
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </Form>)}
    </Container>
  );
};

export default EditCompany;
